var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative", class: _vm.containerClasses },
    [
      _vm.isLink
        ? [
            _vm.itemExtra
              ? _c(
                  "div",
                  {
                    staticClass:
                      "h-4 w-4 rounded-full bg-green-400 absolute bottom-5 left-4 flex items-center justify-center text-2xs text-white z-10 border-white border",
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.itemExtra))])]
                )
              : _vm._e(),
            _c("RouterLink", { attrs: { to: _vm.routeLinkParams } }, [
              _c(
                "span",
                {
                  staticClass:
                    "box-content flex items-start chipHeight border rounded-full cursor-pointer transition delay-100 ease-in duration-75 relative pr-2",
                  class: [_vm.indentationClasses, _vm.removedTextClasses],
                },
                [
                  _vm.shouldDisplayAvatar
                    ? _c(
                        "span",
                        { staticClass: "flex-shrink-0" },
                        [
                          _c("S3Image", {
                            staticClass: "chipHeight circleWidth rounded-full",
                            attrs: { s3FileKey: _vm.avatar },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.shouldDisplayAvatarPlaceholder
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "chipHeight circleWidth bg-primary-500 rounded-full flex items-center text-xl flex-shrink-0 font-semibold justify-center text-white",
                          class: _vm.avatarColor,
                          style: _vm.bgStyle,
                        },
                        [_vm._v(" " + _vm._s(_vm.initial) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "cursor-pointer customMargin w-max-content",
                      class: [_vm.textStylesItem, _vm.blockIndentationClasses],
                    },
                    [
                      _vm._t(
                        "default",
                        function () {
                          return [
                            _c("span", { class: _vm.labelColor }, [
                              _vm._v(" " + _vm._s(_vm.itemName) + " "),
                            ]),
                          ]
                        },
                        { itemName: _vm.itemName }
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ]
        : [
            _c(
              "div",
              {
                staticClass:
                  "box-content flex items-start chipHeight rounded-full text-gray-500 pr-3 gap-2",
                class: [_vm.imageContainerClasses, _vm.indentationClasses],
              },
              [
                _vm.shouldDisplayAvatar
                  ? _c("S3Image", {
                      staticClass: "chipHeight circleWidth rounded-full",
                      attrs: { s3FileKey: _vm.avatar },
                    })
                  : _vm._e(),
                _vm.shouldDisplayAvatarPlaceholder
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "chipHeight flex-shrink-0 circleWidth rounded-full bg-primary-500 flex items-center text-xl font-semibold justify-center text-white",
                        class: [_vm.textStyles, _vm.avatarColor],
                        style: _vm.bgStyle,
                      },
                      [_vm._v(" " + _vm._s(_vm.initial) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "ml-1 w-max-content",
                    class: [_vm.textStylesItem, _vm.blockIndentationClasses],
                  },
                  [
                    _vm._t(
                      "default",
                      function () {
                        return [
                          _vm.management
                            ? _c(
                                "svg",
                                {
                                  staticClass: "h-3 w-4 mt-1 mr-0.5",
                                  attrs: {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M7.03841 6.87773C8.87936 6.87773 10.3717 5.38534 10.3717 3.54439C10.3717 1.70344 8.87936 0.21106 7.03841 0.21106C5.19746 0.21106 3.70508 1.70344 3.70508 3.54439C3.70508 5.38534 5.19746 6.87773 7.03841 6.87773Z",
                                      fill: "#01B549",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M8.02222 16.6111C7.83863 16.4295 7.71883 16.1933 7.68077 15.9379C7.64271 15.6825 7.68844 15.4216 7.81111 15.1944L8.10556 14.6388L7.5 14.4555C7.25306 14.3782 7.03808 14.2225 6.88769 14.0119C6.73729 13.8014 6.65969 13.5475 6.66667 13.2888V12.15C6.6662 11.8924 6.74859 11.6416 6.90165 11.4345C7.05472 11.2274 7.27035 11.0751 7.51667 11L8.12222 10.8166L7.83333 10.2611C7.71426 10.0369 7.66895 9.78096 7.70386 9.52958C7.73877 9.2782 7.85213 9.04425 8.02778 8.86106C7.60038 8.80503 7.16994 8.77535 6.73889 8.77217C5.46573 8.7422 4.20165 8.99354 3.0368 9.50827C1.87195 10.023 0.835029 10.7884 0 11.75V16.0555C0 16.2028 0.0585316 16.3442 0.162718 16.4483C0.266905 16.5525 0.408213 16.6111 0.555556 16.6111H8.02222Z",
                                      fill: "#01B549",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M17.6106 11.9666L16.4995 11.6332C16.4225 11.3588 16.3144 11.0942 16.1773 10.8443L16.7328 9.81101C16.7543 9.77266 16.7621 9.72816 16.7551 9.68478C16.748 9.64139 16.7265 9.60168 16.6939 9.57212L15.8884 8.76101C15.8574 8.73081 15.8178 8.71089 15.7751 8.70393C15.7323 8.69697 15.6885 8.70332 15.6495 8.72212L14.6217 9.27768C14.3687 9.14025 14.1026 9.02858 13.8273 8.94434L13.4884 7.83323C13.4735 7.79226 13.4462 7.75692 13.4104 7.73205C13.3746 7.70718 13.332 7.69401 13.2884 7.69434H12.1328C12.0895 7.69555 12.0476 7.71006 12.0128 7.7359C11.978 7.76174 11.952 7.79766 11.9384 7.83879L11.605 8.9499C11.3244 9.03155 11.0541 9.14526 10.7995 9.28879L9.79394 8.73323C9.75484 8.71245 9.71021 8.70449 9.66634 8.71047C9.62247 8.71646 9.5816 8.73608 9.54949 8.76656L8.73283 9.56656C8.70067 9.59755 8.67948 9.63817 8.67246 9.68228C8.66545 9.72638 8.67299 9.77157 8.69394 9.81101L9.24949 10.8221C9.10067 11.0731 8.97958 11.3394 8.88838 11.6166L7.77727 11.9555C7.73524 11.9676 7.69835 11.9932 7.67226 12.0283C7.64617 12.0634 7.63232 12.1062 7.63283 12.1499V13.2888C7.63232 13.3325 7.64617 13.3752 7.67226 13.4104C7.69835 13.4455 7.73524 13.4711 7.77727 13.4832L8.88838 13.8221C8.97167 14.0942 9.08339 14.3568 9.22171 14.6055L8.66616 15.661C8.64521 15.7004 8.63767 15.7456 8.64469 15.7897C8.6517 15.8338 8.67289 15.8745 8.70505 15.9055L9.53283 16.711C9.56493 16.7415 9.60581 16.7611 9.64967 16.7671C9.69354 16.7731 9.73818 16.7651 9.77727 16.7443L10.8162 16.1888C11.0634 16.3218 11.3241 16.4279 11.5939 16.5055L11.9273 17.6443C11.9413 17.6863 11.9681 17.7229 12.004 17.7488C12.0399 17.7747 12.083 17.7887 12.1273 17.7888H13.2662C13.3095 17.7876 13.3514 17.7731 13.3862 17.7472C13.4209 17.7214 13.4469 17.6855 13.4606 17.6443L13.7939 16.5055C14.0605 16.4289 14.3177 16.3227 14.5606 16.1888L15.6106 16.7443C15.6497 16.7651 15.6943 16.7731 15.7382 16.7671C15.7821 16.7611 15.8229 16.7415 15.855 16.711L16.6662 15.9055C16.6966 15.8733 16.7163 15.8325 16.7222 15.7886C16.7282 15.7447 16.7203 15.7001 16.6995 15.661L16.1439 14.6166C16.2768 14.3732 16.383 14.1161 16.4606 13.8499L17.5717 13.511C17.6135 13.4976 17.6501 13.4718 17.6769 13.4371C17.7037 13.4024 17.7193 13.3603 17.7217 13.3166V12.1666C17.7231 12.1263 17.7134 12.0864 17.6939 12.0512C17.6743 12.0159 17.6455 11.9867 17.6106 11.9666ZM12.705 14.5888C12.3378 14.5899 11.9785 14.482 11.6726 14.2788C11.3668 14.0756 11.1281 13.7861 10.9868 13.4472C10.8455 13.1082 10.8079 12.735 10.8789 12.3746C10.9499 12.0143 11.1262 11.6832 11.3855 11.4231C11.6447 11.1631 11.9753 10.9858 12.3354 10.9137C12.6955 10.8417 13.0689 10.8781 13.4083 11.0184C13.7477 11.1587 14.0378 11.3965 14.2419 11.7018C14.4461 12.007 14.555 12.366 14.555 12.7332C14.5551 13.2244 14.3603 13.6955 14.0135 14.0433C13.6668 14.3912 13.1962 14.5873 12.705 14.5888Z",
                                      fill: "#01B549",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _c("span", { class: _vm.labelColor }, [
                            _vm._v(_vm._s(_vm.itemName)),
                          ]),
                        ]
                      },
                      { itemName: _vm.itemName }
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }